/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AdminRouteImport } from './routes/admin';
import { Route as AppRouteImport } from './routes/app';
import { Route as AdminIndexRouteImport } from './routes/admin.index';
import { Route as AdminAuditLogRouteImport } from './routes/admin.audit-log';
import { Route as AdminChangePasswordRouteImport } from './routes/admin.change-password';
import { Route as AdminInvitesRouteImport } from './routes/admin.invites';
import { Route as AdminKycRouteImport } from './routes/admin.kyc';
import { Route as AdminNotasFiscaisRouteImport } from './routes/admin.notas-fiscais';
import { Route as AdminReconciliationRouteImport } from './routes/admin.reconciliation';
import { Route as AdminSellersRouteImport } from './routes/admin.sellers';
import { Route as AdminSetup2faRouteImport } from './routes/admin.setup-2fa';
import { Route as AdminTransactionsRouteImport } from './routes/admin.transactions';
import { Route as AdminWithdrawalsRouteImport } from './routes/admin.withdrawals';
import { Route as AppIndexRouteImport } from './routes/app.index';
import { Route as AppNotasFiscaisRouteImport } from './routes/app.notas-fiscais';
import { Route as AppSplitsRouteImport } from './routes/app.splits';
import { Route as AppTermsRouteImport } from './routes/app.terms';
import { Route as AppTransactionsRouteImport } from './routes/app.transactions';
import { Route as AppWithdrawalsRouteImport } from './routes/app.withdrawals';
import { Route as DevKitRouteImport } from './routes/dev.kit';
import { Route as ForgotPasswordIndexRouteImport } from './routes/forgot-password.index';
import { Route as LoginIndexRouteImport } from './routes/login.index';
import { Route as NoAccessIndexRouteImport } from './routes/no-access.index';
import { Route as Recover2faIndexRouteImport } from './routes/recover-2fa.index';
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password.index';
import { Route as SignupIndexRouteImport } from './routes/signup.index';
import { Route as VerifyEmailIndexRouteImport } from './routes/verify-email.index';
import { Route as AdminAcquirersIndexRouteImport } from './routes/admin.acquirers.index';
import { Route as AdminAdminsIndexRouteImport } from './routes/admin.admins.index';
import { Route as AdminAlertsIndexRouteImport } from './routes/admin.alerts.index';
import { Route as AdminAuditLogIndexRouteImport } from './routes/admin.audit-log.index';
import { Route as AdminAuditLogIdRouteImport } from './routes/admin.audit-log.$id';
import { Route as AdminKycIndexRouteImport } from './routes/admin.kyc.index';
import { Route as AdminKycIdRouteImport } from './routes/admin.kyc.$id';
import { Route as AdminLedgerIndexRouteImport } from './routes/admin.ledger.index';
import { Route as AdminRatesIndexRouteImport } from './routes/admin.rates.index';
import { Route as AdminReconciliationIndexRouteImport } from './routes/admin.reconciliation.index';
import { Route as AdminReportsIndexRouteImport } from './routes/admin.reports.index';
import { Route as AdminSellersIndexRouteImport } from './routes/admin.sellers.index';
import { Route as AdminSellersIdRouteImport } from './routes/admin.sellers.$id';
import { Route as AdminSettingsIndexRouteImport } from './routes/admin.settings.index';
import { Route as AdminSystemIndexRouteImport } from './routes/admin.system.index';
import { Route as AdminTransactionsIndexRouteImport } from './routes/admin.transactions.index';
import { Route as AdminTransactionsIdRouteImport } from './routes/admin.transactions.$id';
import { Route as AdminWebhooksInboxRouteImport } from './routes/admin.webhooks.inbox';
import { Route as AdminWithdrawalsIndexRouteImport } from './routes/admin.withdrawals.index';
import { Route as AdminWithdrawalsIdRouteImport } from './routes/admin.withdrawals.$id';
import { Route as AppBalanceIndexRouteImport } from './routes/app.balance.index';
import { Route as AppDevelopersIndexRouteImport } from './routes/app.developers.index';
import { Route as AppReportsIndexRouteImport } from './routes/app.reports.index';
import { Route as AppSettingsIndexRouteImport } from './routes/app.settings.index';
import { Route as AppSplitsIndexRouteImport } from './routes/app.splits.index';
import { Route as AppSplitsIdRouteImport } from './routes/app.splits.$id';
import { Route as AppSplitsAuthorizationsRouteImport } from './routes/app.splits.authorizations';
import { Route as AppTransactionsIndexRouteImport } from './routes/app.transactions.index';
import { Route as AppTransactionsIdRouteImport } from './routes/app.transactions.$id';
import { Route as AppWithdrawalsIndexRouteImport } from './routes/app.withdrawals.index';
import { Route as AppWithdrawalsIdRouteImport } from './routes/app.withdrawals.$id';
import { Route as AdminReconciliationRunsIdRouteImport } from './routes/admin.reconciliation.runs.$id';
import { Route as AdminWebhooksDeliveriesIndexRouteImport } from './routes/admin.webhooks.deliveries.index';
import { Route as AdminWebhooksInboxIndexRouteImport } from './routes/admin.webhooks.inbox.index';
import { Route as AdminWebhooksInboxIdRouteImport } from './routes/admin.webhooks.inbox.$id';
import { Route as AppDevelopersApiKeysIndexRouteImport } from './routes/app.developers.api-keys.index';
import { Route as AppDevelopersDocsIndexRouteImport } from './routes/app.developers.docs.index';
import { Route as AppDevelopersEventsIndexRouteImport } from './routes/app.developers.events.index';
import { Route as AppDevelopersWebhooksIndexRouteImport } from './routes/app.developers.webhooks.index';
import { Route as AppSettingsIntegrationsIndexRouteImport } from './routes/app.settings.integrations.index';
import { Route as AppSettingsKycIndexRouteImport } from './routes/app.settings.kyc.index';
import { Route as AppSettingsNotificationsIndexRouteImport } from './routes/app.settings.notifications.index';
import { Route as AppSettingsPixKeysIndexRouteImport } from './routes/app.settings.pix-keys.index';
import { Route as AppSettingsRatesIndexRouteImport } from './routes/app.settings.rates.index';
import { Route as AppSettingsSecurityIndexRouteImport } from './routes/app.settings.security.index';
import { Route as AppDevelopersWebhooksDeliveriesIndexRouteImport } from './routes/app.developers.webhooks.deliveries.index';

const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AdminRoute,
} as any);
const AdminChangePasswordRoute = AdminChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AdminRoute,
} as any);
const AdminInvitesRoute = AdminInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AdminRoute,
} as any);
const AdminKycRoute = AdminKycRouteImport.update({
  id: '/kyc',
  path: '/kyc',
  getParentRoute: () => AdminRoute,
} as any);
const AdminNotasFiscaisRoute = AdminNotasFiscaisRouteImport.update({
  id: '/notas-fiscais',
  path: '/notas-fiscais',
  getParentRoute: () => AdminRoute,
} as any);
const AdminReconciliationRoute = AdminReconciliationRouteImport.update({
  id: '/reconciliation',
  path: '/reconciliation',
  getParentRoute: () => AdminRoute,
} as any);
const AdminSellersRoute = AdminSellersRouteImport.update({
  id: '/sellers',
  path: '/sellers',
  getParentRoute: () => AdminRoute,
} as any);
const AdminSetup2faRoute = AdminSetup2faRouteImport.update({
  id: '/setup-2fa',
  path: '/setup-2fa',
  getParentRoute: () => AdminRoute,
} as any);
const AdminTransactionsRoute = AdminTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AdminRoute,
} as any);
const AdminWithdrawalsRoute = AdminWithdrawalsRouteImport.update({
  id: '/withdrawals',
  path: '/withdrawals',
  getParentRoute: () => AdminRoute,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any);
const AppNotasFiscaisRoute = AppNotasFiscaisRouteImport.update({
  id: '/notas-fiscais',
  path: '/notas-fiscais',
  getParentRoute: () => AppRoute,
} as any);
const AppSplitsRoute = AppSplitsRouteImport.update({
  id: '/splits',
  path: '/splits',
  getParentRoute: () => AppRoute,
} as any);
const AppTermsRoute = AppTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AppRoute,
} as any);
const AppTransactionsRoute = AppTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AppRoute,
} as any);
const AppWithdrawalsRoute = AppWithdrawalsRouteImport.update({
  id: '/withdrawals',
  path: '/withdrawals',
  getParentRoute: () => AppRoute,
} as any);
const DevKitRoute = DevKitRouteImport.update({
  id: '/dev/kit',
  path: '/dev/kit',
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordIndexRoute = ForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any);
const NoAccessIndexRoute = NoAccessIndexRouteImport.update({
  id: '/no-access/',
  path: '/no-access/',
  getParentRoute: () => rootRouteImport,
} as any);
const Recover2faIndexRoute = Recover2faIndexRouteImport.update({
  id: '/recover-2fa/',
  path: '/recover-2fa/',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any);
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => rootRouteImport,
} as any);
const VerifyEmailIndexRoute = VerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminAcquirersIndexRoute = AdminAcquirersIndexRouteImport.update({
  id: '/acquirers/',
  path: '/acquirers/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminAdminsIndexRoute = AdminAdminsIndexRouteImport.update({
  id: '/admins/',
  path: '/admins/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminAlertsIndexRoute = AdminAlertsIndexRouteImport.update({
  id: '/alerts/',
  path: '/alerts/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminAuditLogIndexRoute = AdminAuditLogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAuditLogRoute,
} as any);
const AdminAuditLogIdRoute = AdminAuditLogIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminAuditLogRoute,
} as any);
const AdminKycIndexRoute = AdminKycIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminKycRoute,
} as any);
const AdminKycIdRoute = AdminKycIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminKycRoute,
} as any);
const AdminLedgerIndexRoute = AdminLedgerIndexRouteImport.update({
  id: '/ledger/',
  path: '/ledger/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminRatesIndexRoute = AdminRatesIndexRouteImport.update({
  id: '/rates/',
  path: '/rates/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminReconciliationIndexRoute =
  AdminReconciliationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminReconciliationRoute,
  } as any);
const AdminReportsIndexRoute = AdminReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminSellersIndexRoute = AdminSellersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSellersRoute,
} as any);
const AdminSellersIdRoute = AdminSellersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminSellersRoute,
} as any);
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminSystemIndexRoute = AdminSystemIndexRouteImport.update({
  id: '/system/',
  path: '/system/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminTransactionsIndexRoute = AdminTransactionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminTransactionsRoute,
} as any);
const AdminTransactionsIdRoute = AdminTransactionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminTransactionsRoute,
} as any);
const AdminWebhooksInboxRoute = AdminWebhooksInboxRouteImport.update({
  id: '/webhooks/inbox',
  path: '/webhooks/inbox',
  getParentRoute: () => AdminRoute,
} as any);
const AdminWithdrawalsIndexRoute = AdminWithdrawalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminWithdrawalsRoute,
} as any);
const AdminWithdrawalsIdRoute = AdminWithdrawalsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminWithdrawalsRoute,
} as any);
const AppBalanceIndexRoute = AppBalanceIndexRouteImport.update({
  id: '/balance/',
  path: '/balance/',
  getParentRoute: () => AppRoute,
} as any);
const AppDevelopersIndexRoute = AppDevelopersIndexRouteImport.update({
  id: '/developers/',
  path: '/developers/',
  getParentRoute: () => AppRoute,
} as any);
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any);
const AppSplitsIndexRoute = AppSplitsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSplitsRoute,
} as any);
const AppSplitsIdRoute = AppSplitsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppSplitsRoute,
} as any);
const AppSplitsAuthorizationsRoute = AppSplitsAuthorizationsRouteImport.update({
  id: '/authorizations',
  path: '/authorizations',
  getParentRoute: () => AppSplitsRoute,
} as any);
const AppTransactionsIndexRoute = AppTransactionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTransactionsRoute,
} as any);
const AppTransactionsIdRoute = AppTransactionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppTransactionsRoute,
} as any);
const AppWithdrawalsIndexRoute = AppWithdrawalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWithdrawalsRoute,
} as any);
const AppWithdrawalsIdRoute = AppWithdrawalsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppWithdrawalsRoute,
} as any);
const AdminReconciliationRunsIdRoute =
  AdminReconciliationRunsIdRouteImport.update({
    id: '/runs/$id',
    path: '/runs/$id',
    getParentRoute: () => AdminReconciliationRoute,
  } as any);
const AdminWebhooksDeliveriesIndexRoute =
  AdminWebhooksDeliveriesIndexRouteImport.update({
    id: '/webhooks/deliveries/',
    path: '/webhooks/deliveries/',
    getParentRoute: () => AdminRoute,
  } as any);
const AdminWebhooksInboxIndexRoute = AdminWebhooksInboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminWebhooksInboxRoute,
} as any);
const AdminWebhooksInboxIdRoute = AdminWebhooksInboxIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminWebhooksInboxRoute,
} as any);
const AppDevelopersApiKeysIndexRoute =
  AppDevelopersApiKeysIndexRouteImport.update({
    id: '/developers/api-keys/',
    path: '/developers/api-keys/',
    getParentRoute: () => AppRoute,
  } as any);
const AppDevelopersDocsIndexRoute = AppDevelopersDocsIndexRouteImport.update({
  id: '/developers/docs/',
  path: '/developers/docs/',
  getParentRoute: () => AppRoute,
} as any);
const AppDevelopersEventsIndexRoute =
  AppDevelopersEventsIndexRouteImport.update({
    id: '/developers/events/',
    path: '/developers/events/',
    getParentRoute: () => AppRoute,
  } as any);
const AppDevelopersWebhooksIndexRoute =
  AppDevelopersWebhooksIndexRouteImport.update({
    id: '/developers/webhooks/',
    path: '/developers/webhooks/',
    getParentRoute: () => AppRoute,
  } as any);
const AppSettingsIntegrationsIndexRoute =
  AppSettingsIntegrationsIndexRouteImport.update({
    id: '/settings/integrations/',
    path: '/settings/integrations/',
    getParentRoute: () => AppRoute,
  } as any);
const AppSettingsKycIndexRoute = AppSettingsKycIndexRouteImport.update({
  id: '/settings/kyc/',
  path: '/settings/kyc/',
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsNotificationsIndexRoute =
  AppSettingsNotificationsIndexRouteImport.update({
    id: '/settings/notifications/',
    path: '/settings/notifications/',
    getParentRoute: () => AppRoute,
  } as any);
const AppSettingsPixKeysIndexRoute = AppSettingsPixKeysIndexRouteImport.update({
  id: '/settings/pix-keys/',
  path: '/settings/pix-keys/',
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsRatesIndexRoute = AppSettingsRatesIndexRouteImport.update({
  id: '/settings/rates/',
  path: '/settings/rates/',
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsSecurityIndexRoute =
  AppSettingsSecurityIndexRouteImport.update({
    id: '/settings/security/',
    path: '/settings/security/',
    getParentRoute: () => AppRoute,
  } as any);
const AppDevelopersWebhooksDeliveriesIndexRoute =
  AppDevelopersWebhooksDeliveriesIndexRouteImport.update({
    id: '/developers/webhooks/deliveries/',
    path: '/developers/webhooks/deliveries/',
    getParentRoute: () => AppRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRouteWithChildren;
  '/app': typeof AppRouteWithChildren;
  '/admin/audit-log': typeof AdminAuditLogRouteWithChildren;
  '/admin/change-password': typeof AdminChangePasswordRoute;
  '/admin/invites': typeof AdminInvitesRoute;
  '/admin/kyc': typeof AdminKycRouteWithChildren;
  '/admin/notas-fiscais': typeof AdminNotasFiscaisRoute;
  '/admin/reconciliation': typeof AdminReconciliationRouteWithChildren;
  '/admin/sellers': typeof AdminSellersRouteWithChildren;
  '/admin/setup-2fa': typeof AdminSetup2faRoute;
  '/admin/transactions': typeof AdminTransactionsRouteWithChildren;
  '/admin/withdrawals': typeof AdminWithdrawalsRouteWithChildren;
  '/app/notas-fiscais': typeof AppNotasFiscaisRoute;
  '/app/splits': typeof AppSplitsRouteWithChildren;
  '/app/terms': typeof AppTermsRoute;
  '/app/transactions': typeof AppTransactionsRouteWithChildren;
  '/app/withdrawals': typeof AppWithdrawalsRouteWithChildren;
  '/dev/kit': typeof DevKitRoute;
  '/admin/': typeof AdminIndexRoute;
  '/app/': typeof AppIndexRoute;
  '/forgot-password/': typeof ForgotPasswordIndexRoute;
  '/login/': typeof LoginIndexRoute;
  '/no-access/': typeof NoAccessIndexRoute;
  '/recover-2fa/': typeof Recover2faIndexRoute;
  '/reset-password/': typeof ResetPasswordIndexRoute;
  '/signup/': typeof SignupIndexRoute;
  '/verify-email/': typeof VerifyEmailIndexRoute;
  '/admin/audit-log/$id': typeof AdminAuditLogIdRoute;
  '/admin/kyc/$id': typeof AdminKycIdRoute;
  '/admin/sellers/$id': typeof AdminSellersIdRoute;
  '/admin/transactions/$id': typeof AdminTransactionsIdRoute;
  '/admin/webhooks/inbox': typeof AdminWebhooksInboxRouteWithChildren;
  '/admin/withdrawals/$id': typeof AdminWithdrawalsIdRoute;
  '/app/splits/$id': typeof AppSplitsIdRoute;
  '/app/splits/authorizations': typeof AppSplitsAuthorizationsRoute;
  '/app/transactions/$id': typeof AppTransactionsIdRoute;
  '/app/withdrawals/$id': typeof AppWithdrawalsIdRoute;
  '/admin/acquirers/': typeof AdminAcquirersIndexRoute;
  '/admin/admins/': typeof AdminAdminsIndexRoute;
  '/admin/alerts/': typeof AdminAlertsIndexRoute;
  '/admin/audit-log/': typeof AdminAuditLogIndexRoute;
  '/admin/kyc/': typeof AdminKycIndexRoute;
  '/admin/ledger/': typeof AdminLedgerIndexRoute;
  '/admin/rates/': typeof AdminRatesIndexRoute;
  '/admin/reconciliation/': typeof AdminReconciliationIndexRoute;
  '/admin/reports/': typeof AdminReportsIndexRoute;
  '/admin/sellers/': typeof AdminSellersIndexRoute;
  '/admin/settings/': typeof AdminSettingsIndexRoute;
  '/admin/system/': typeof AdminSystemIndexRoute;
  '/admin/transactions/': typeof AdminTransactionsIndexRoute;
  '/admin/withdrawals/': typeof AdminWithdrawalsIndexRoute;
  '/app/balance/': typeof AppBalanceIndexRoute;
  '/app/developers/': typeof AppDevelopersIndexRoute;
  '/app/reports/': typeof AppReportsIndexRoute;
  '/app/settings/': typeof AppSettingsIndexRoute;
  '/app/splits/': typeof AppSplitsIndexRoute;
  '/app/transactions/': typeof AppTransactionsIndexRoute;
  '/app/withdrawals/': typeof AppWithdrawalsIndexRoute;
  '/admin/reconciliation/runs/$id': typeof AdminReconciliationRunsIdRoute;
  '/admin/webhooks/inbox/$id': typeof AdminWebhooksInboxIdRoute;
  '/admin/webhooks/deliveries/': typeof AdminWebhooksDeliveriesIndexRoute;
  '/admin/webhooks/inbox/': typeof AdminWebhooksInboxIndexRoute;
  '/app/developers/api-keys/': typeof AppDevelopersApiKeysIndexRoute;
  '/app/developers/docs/': typeof AppDevelopersDocsIndexRoute;
  '/app/developers/events/': typeof AppDevelopersEventsIndexRoute;
  '/app/developers/webhooks/': typeof AppDevelopersWebhooksIndexRoute;
  '/app/settings/integrations/': typeof AppSettingsIntegrationsIndexRoute;
  '/app/settings/kyc/': typeof AppSettingsKycIndexRoute;
  '/app/settings/notifications/': typeof AppSettingsNotificationsIndexRoute;
  '/app/settings/pix-keys/': typeof AppSettingsPixKeysIndexRoute;
  '/app/settings/rates/': typeof AppSettingsRatesIndexRoute;
  '/app/settings/security/': typeof AppSettingsSecurityIndexRoute;
  '/app/developers/webhooks/deliveries/': typeof AppDevelopersWebhooksDeliveriesIndexRoute;
}
export interface FileRoutesByTo {
  '/admin/change-password': typeof AdminChangePasswordRoute;
  '/admin/invites': typeof AdminInvitesRoute;
  '/admin/notas-fiscais': typeof AdminNotasFiscaisRoute;
  '/admin/setup-2fa': typeof AdminSetup2faRoute;
  '/app/notas-fiscais': typeof AppNotasFiscaisRoute;
  '/app/terms': typeof AppTermsRoute;
  '/dev/kit': typeof DevKitRoute;
  '/admin': typeof AdminIndexRoute;
  '/app': typeof AppIndexRoute;
  '/forgot-password': typeof ForgotPasswordIndexRoute;
  '/login': typeof LoginIndexRoute;
  '/no-access': typeof NoAccessIndexRoute;
  '/recover-2fa': typeof Recover2faIndexRoute;
  '/reset-password': typeof ResetPasswordIndexRoute;
  '/signup': typeof SignupIndexRoute;
  '/verify-email': typeof VerifyEmailIndexRoute;
  '/admin/audit-log/$id': typeof AdminAuditLogIdRoute;
  '/admin/kyc/$id': typeof AdminKycIdRoute;
  '/admin/sellers/$id': typeof AdminSellersIdRoute;
  '/admin/transactions/$id': typeof AdminTransactionsIdRoute;
  '/admin/withdrawals/$id': typeof AdminWithdrawalsIdRoute;
  '/app/splits/$id': typeof AppSplitsIdRoute;
  '/app/splits/authorizations': typeof AppSplitsAuthorizationsRoute;
  '/app/transactions/$id': typeof AppTransactionsIdRoute;
  '/app/withdrawals/$id': typeof AppWithdrawalsIdRoute;
  '/admin/acquirers': typeof AdminAcquirersIndexRoute;
  '/admin/admins': typeof AdminAdminsIndexRoute;
  '/admin/alerts': typeof AdminAlertsIndexRoute;
  '/admin/audit-log': typeof AdminAuditLogIndexRoute;
  '/admin/kyc': typeof AdminKycIndexRoute;
  '/admin/ledger': typeof AdminLedgerIndexRoute;
  '/admin/rates': typeof AdminRatesIndexRoute;
  '/admin/reconciliation': typeof AdminReconciliationIndexRoute;
  '/admin/reports': typeof AdminReportsIndexRoute;
  '/admin/sellers': typeof AdminSellersIndexRoute;
  '/admin/settings': typeof AdminSettingsIndexRoute;
  '/admin/system': typeof AdminSystemIndexRoute;
  '/admin/transactions': typeof AdminTransactionsIndexRoute;
  '/admin/withdrawals': typeof AdminWithdrawalsIndexRoute;
  '/app/balance': typeof AppBalanceIndexRoute;
  '/app/developers': typeof AppDevelopersIndexRoute;
  '/app/reports': typeof AppReportsIndexRoute;
  '/app/settings': typeof AppSettingsIndexRoute;
  '/app/splits': typeof AppSplitsIndexRoute;
  '/app/transactions': typeof AppTransactionsIndexRoute;
  '/app/withdrawals': typeof AppWithdrawalsIndexRoute;
  '/admin/reconciliation/runs/$id': typeof AdminReconciliationRunsIdRoute;
  '/admin/webhooks/inbox/$id': typeof AdminWebhooksInboxIdRoute;
  '/admin/webhooks/deliveries': typeof AdminWebhooksDeliveriesIndexRoute;
  '/admin/webhooks/inbox': typeof AdminWebhooksInboxIndexRoute;
  '/app/developers/api-keys': typeof AppDevelopersApiKeysIndexRoute;
  '/app/developers/docs': typeof AppDevelopersDocsIndexRoute;
  '/app/developers/events': typeof AppDevelopersEventsIndexRoute;
  '/app/developers/webhooks': typeof AppDevelopersWebhooksIndexRoute;
  '/app/settings/integrations': typeof AppSettingsIntegrationsIndexRoute;
  '/app/settings/kyc': typeof AppSettingsKycIndexRoute;
  '/app/settings/notifications': typeof AppSettingsNotificationsIndexRoute;
  '/app/settings/pix-keys': typeof AppSettingsPixKeysIndexRoute;
  '/app/settings/rates': typeof AppSettingsRatesIndexRoute;
  '/app/settings/security': typeof AppSettingsSecurityIndexRoute;
  '/app/developers/webhooks/deliveries': typeof AppDevelopersWebhooksDeliveriesIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/admin': typeof AdminRouteWithChildren;
  '/app': typeof AppRouteWithChildren;
  '/admin/audit-log': typeof AdminAuditLogRouteWithChildren;
  '/admin/change-password': typeof AdminChangePasswordRoute;
  '/admin/invites': typeof AdminInvitesRoute;
  '/admin/kyc': typeof AdminKycRouteWithChildren;
  '/admin/notas-fiscais': typeof AdminNotasFiscaisRoute;
  '/admin/reconciliation': typeof AdminReconciliationRouteWithChildren;
  '/admin/sellers': typeof AdminSellersRouteWithChildren;
  '/admin/setup-2fa': typeof AdminSetup2faRoute;
  '/admin/transactions': typeof AdminTransactionsRouteWithChildren;
  '/admin/withdrawals': typeof AdminWithdrawalsRouteWithChildren;
  '/app/notas-fiscais': typeof AppNotasFiscaisRoute;
  '/app/splits': typeof AppSplitsRouteWithChildren;
  '/app/terms': typeof AppTermsRoute;
  '/app/transactions': typeof AppTransactionsRouteWithChildren;
  '/app/withdrawals': typeof AppWithdrawalsRouteWithChildren;
  '/dev/kit': typeof DevKitRoute;
  '/admin/': typeof AdminIndexRoute;
  '/app/': typeof AppIndexRoute;
  '/forgot-password/': typeof ForgotPasswordIndexRoute;
  '/login/': typeof LoginIndexRoute;
  '/no-access/': typeof NoAccessIndexRoute;
  '/recover-2fa/': typeof Recover2faIndexRoute;
  '/reset-password/': typeof ResetPasswordIndexRoute;
  '/signup/': typeof SignupIndexRoute;
  '/verify-email/': typeof VerifyEmailIndexRoute;
  '/admin/audit-log/$id': typeof AdminAuditLogIdRoute;
  '/admin/kyc/$id': typeof AdminKycIdRoute;
  '/admin/sellers/$id': typeof AdminSellersIdRoute;
  '/admin/transactions/$id': typeof AdminTransactionsIdRoute;
  '/admin/webhooks/inbox': typeof AdminWebhooksInboxRouteWithChildren;
  '/admin/withdrawals/$id': typeof AdminWithdrawalsIdRoute;
  '/app/splits/$id': typeof AppSplitsIdRoute;
  '/app/splits/authorizations': typeof AppSplitsAuthorizationsRoute;
  '/app/transactions/$id': typeof AppTransactionsIdRoute;
  '/app/withdrawals/$id': typeof AppWithdrawalsIdRoute;
  '/admin/acquirers/': typeof AdminAcquirersIndexRoute;
  '/admin/admins/': typeof AdminAdminsIndexRoute;
  '/admin/alerts/': typeof AdminAlertsIndexRoute;
  '/admin/audit-log/': typeof AdminAuditLogIndexRoute;
  '/admin/kyc/': typeof AdminKycIndexRoute;
  '/admin/ledger/': typeof AdminLedgerIndexRoute;
  '/admin/rates/': typeof AdminRatesIndexRoute;
  '/admin/reconciliation/': typeof AdminReconciliationIndexRoute;
  '/admin/reports/': typeof AdminReportsIndexRoute;
  '/admin/sellers/': typeof AdminSellersIndexRoute;
  '/admin/settings/': typeof AdminSettingsIndexRoute;
  '/admin/system/': typeof AdminSystemIndexRoute;
  '/admin/transactions/': typeof AdminTransactionsIndexRoute;
  '/admin/withdrawals/': typeof AdminWithdrawalsIndexRoute;
  '/app/balance/': typeof AppBalanceIndexRoute;
  '/app/developers/': typeof AppDevelopersIndexRoute;
  '/app/reports/': typeof AppReportsIndexRoute;
  '/app/settings/': typeof AppSettingsIndexRoute;
  '/app/splits/': typeof AppSplitsIndexRoute;
  '/app/transactions/': typeof AppTransactionsIndexRoute;
  '/app/withdrawals/': typeof AppWithdrawalsIndexRoute;
  '/admin/reconciliation/runs/$id': typeof AdminReconciliationRunsIdRoute;
  '/admin/webhooks/inbox/$id': typeof AdminWebhooksInboxIdRoute;
  '/admin/webhooks/deliveries/': typeof AdminWebhooksDeliveriesIndexRoute;
  '/admin/webhooks/inbox/': typeof AdminWebhooksInboxIndexRoute;
  '/app/developers/api-keys/': typeof AppDevelopersApiKeysIndexRoute;
  '/app/developers/docs/': typeof AppDevelopersDocsIndexRoute;
  '/app/developers/events/': typeof AppDevelopersEventsIndexRoute;
  '/app/developers/webhooks/': typeof AppDevelopersWebhooksIndexRoute;
  '/app/settings/integrations/': typeof AppSettingsIntegrationsIndexRoute;
  '/app/settings/kyc/': typeof AppSettingsKycIndexRoute;
  '/app/settings/notifications/': typeof AppSettingsNotificationsIndexRoute;
  '/app/settings/pix-keys/': typeof AppSettingsPixKeysIndexRoute;
  '/app/settings/rates/': typeof AppSettingsRatesIndexRoute;
  '/app/settings/security/': typeof AppSettingsSecurityIndexRoute;
  '/app/developers/webhooks/deliveries/': typeof AppDevelopersWebhooksDeliveriesIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/admin'
    | '/app'
    | '/admin/audit-log'
    | '/admin/change-password'
    | '/admin/invites'
    | '/admin/kyc'
    | '/admin/notas-fiscais'
    | '/admin/reconciliation'
    | '/admin/sellers'
    | '/admin/setup-2fa'
    | '/admin/transactions'
    | '/admin/withdrawals'
    | '/app/notas-fiscais'
    | '/app/splits'
    | '/app/terms'
    | '/app/transactions'
    | '/app/withdrawals'
    | '/dev/kit'
    | '/admin/'
    | '/app/'
    | '/forgot-password/'
    | '/login/'
    | '/no-access/'
    | '/recover-2fa/'
    | '/reset-password/'
    | '/signup/'
    | '/verify-email/'
    | '/admin/audit-log/$id'
    | '/admin/kyc/$id'
    | '/admin/sellers/$id'
    | '/admin/transactions/$id'
    | '/admin/webhooks/inbox'
    | '/admin/withdrawals/$id'
    | '/app/splits/$id'
    | '/app/splits/authorizations'
    | '/app/transactions/$id'
    | '/app/withdrawals/$id'
    | '/admin/acquirers/'
    | '/admin/admins/'
    | '/admin/alerts/'
    | '/admin/audit-log/'
    | '/admin/kyc/'
    | '/admin/ledger/'
    | '/admin/rates/'
    | '/admin/reconciliation/'
    | '/admin/reports/'
    | '/admin/sellers/'
    | '/admin/settings/'
    | '/admin/system/'
    | '/admin/transactions/'
    | '/admin/withdrawals/'
    | '/app/balance/'
    | '/app/developers/'
    | '/app/reports/'
    | '/app/settings/'
    | '/app/splits/'
    | '/app/transactions/'
    | '/app/withdrawals/'
    | '/admin/reconciliation/runs/$id'
    | '/admin/webhooks/inbox/$id'
    | '/admin/webhooks/deliveries/'
    | '/admin/webhooks/inbox/'
    | '/app/developers/api-keys/'
    | '/app/developers/docs/'
    | '/app/developers/events/'
    | '/app/developers/webhooks/'
    | '/app/settings/integrations/'
    | '/app/settings/kyc/'
    | '/app/settings/notifications/'
    | '/app/settings/pix-keys/'
    | '/app/settings/rates/'
    | '/app/settings/security/'
    | '/app/developers/webhooks/deliveries/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/admin/change-password'
    | '/admin/invites'
    | '/admin/notas-fiscais'
    | '/admin/setup-2fa'
    | '/app/notas-fiscais'
    | '/app/terms'
    | '/dev/kit'
    | '/admin'
    | '/app'
    | '/forgot-password'
    | '/login'
    | '/no-access'
    | '/recover-2fa'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/admin/audit-log/$id'
    | '/admin/kyc/$id'
    | '/admin/sellers/$id'
    | '/admin/transactions/$id'
    | '/admin/withdrawals/$id'
    | '/app/splits/$id'
    | '/app/splits/authorizations'
    | '/app/transactions/$id'
    | '/app/withdrawals/$id'
    | '/admin/acquirers'
    | '/admin/admins'
    | '/admin/alerts'
    | '/admin/audit-log'
    | '/admin/kyc'
    | '/admin/ledger'
    | '/admin/rates'
    | '/admin/reconciliation'
    | '/admin/reports'
    | '/admin/sellers'
    | '/admin/settings'
    | '/admin/system'
    | '/admin/transactions'
    | '/admin/withdrawals'
    | '/app/balance'
    | '/app/developers'
    | '/app/reports'
    | '/app/settings'
    | '/app/splits'
    | '/app/transactions'
    | '/app/withdrawals'
    | '/admin/reconciliation/runs/$id'
    | '/admin/webhooks/inbox/$id'
    | '/admin/webhooks/deliveries'
    | '/admin/webhooks/inbox'
    | '/app/developers/api-keys'
    | '/app/developers/docs'
    | '/app/developers/events'
    | '/app/developers/webhooks'
    | '/app/settings/integrations'
    | '/app/settings/kyc'
    | '/app/settings/notifications'
    | '/app/settings/pix-keys'
    | '/app/settings/rates'
    | '/app/settings/security'
    | '/app/developers/webhooks/deliveries';
  id:
    | '__root__'
    | '/admin'
    | '/app'
    | '/admin/audit-log'
    | '/admin/change-password'
    | '/admin/invites'
    | '/admin/kyc'
    | '/admin/notas-fiscais'
    | '/admin/reconciliation'
    | '/admin/sellers'
    | '/admin/setup-2fa'
    | '/admin/transactions'
    | '/admin/withdrawals'
    | '/app/notas-fiscais'
    | '/app/splits'
    | '/app/terms'
    | '/app/transactions'
    | '/app/withdrawals'
    | '/dev/kit'
    | '/admin/'
    | '/app/'
    | '/forgot-password/'
    | '/login/'
    | '/no-access/'
    | '/recover-2fa/'
    | '/reset-password/'
    | '/signup/'
    | '/verify-email/'
    | '/admin/audit-log/$id'
    | '/admin/kyc/$id'
    | '/admin/sellers/$id'
    | '/admin/transactions/$id'
    | '/admin/webhooks/inbox'
    | '/admin/withdrawals/$id'
    | '/app/splits/$id'
    | '/app/splits/authorizations'
    | '/app/transactions/$id'
    | '/app/withdrawals/$id'
    | '/admin/acquirers/'
    | '/admin/admins/'
    | '/admin/alerts/'
    | '/admin/audit-log/'
    | '/admin/kyc/'
    | '/admin/ledger/'
    | '/admin/rates/'
    | '/admin/reconciliation/'
    | '/admin/reports/'
    | '/admin/sellers/'
    | '/admin/settings/'
    | '/admin/system/'
    | '/admin/transactions/'
    | '/admin/withdrawals/'
    | '/app/balance/'
    | '/app/developers/'
    | '/app/reports/'
    | '/app/settings/'
    | '/app/splits/'
    | '/app/transactions/'
    | '/app/withdrawals/'
    | '/admin/reconciliation/runs/$id'
    | '/admin/webhooks/inbox/$id'
    | '/admin/webhooks/deliveries/'
    | '/admin/webhooks/inbox/'
    | '/app/developers/api-keys/'
    | '/app/developers/docs/'
    | '/app/developers/events/'
    | '/app/developers/webhooks/'
    | '/app/settings/integrations/'
    | '/app/settings/kyc/'
    | '/app/settings/notifications/'
    | '/app/settings/pix-keys/'
    | '/app/settings/rates/'
    | '/app/settings/security/'
    | '/app/developers/webhooks/deliveries/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRouteWithChildren;
  AppRoute: typeof AppRouteWithChildren;
  DevKitRoute: typeof DevKitRoute;
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute;
  LoginIndexRoute: typeof LoginIndexRoute;
  NoAccessIndexRoute: typeof NoAccessIndexRoute;
  Recover2faIndexRoute: typeof Recover2faIndexRoute;
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute;
  SignupIndexRoute: typeof SignupIndexRoute;
  VerifyEmailIndexRoute: typeof VerifyEmailIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/app': {
      id: '/app';
      path: '/app';
      fullPath: '/app';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin/': {
      id: '/admin/';
      path: '/';
      fullPath: '/admin/';
      preLoaderRoute: typeof AdminIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/audit-log': {
      id: '/admin/audit-log';
      path: '/audit-log';
      fullPath: '/admin/audit-log';
      preLoaderRoute: typeof AdminAuditLogRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/change-password': {
      id: '/admin/change-password';
      path: '/change-password';
      fullPath: '/admin/change-password';
      preLoaderRoute: typeof AdminChangePasswordRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/invites': {
      id: '/admin/invites';
      path: '/invites';
      fullPath: '/admin/invites';
      preLoaderRoute: typeof AdminInvitesRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/kyc': {
      id: '/admin/kyc';
      path: '/kyc';
      fullPath: '/admin/kyc';
      preLoaderRoute: typeof AdminKycRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/notas-fiscais': {
      id: '/admin/notas-fiscais';
      path: '/notas-fiscais';
      fullPath: '/admin/notas-fiscais';
      preLoaderRoute: typeof AdminNotasFiscaisRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/reconciliation': {
      id: '/admin/reconciliation';
      path: '/reconciliation';
      fullPath: '/admin/reconciliation';
      preLoaderRoute: typeof AdminReconciliationRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/sellers': {
      id: '/admin/sellers';
      path: '/sellers';
      fullPath: '/admin/sellers';
      preLoaderRoute: typeof AdminSellersRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/setup-2fa': {
      id: '/admin/setup-2fa';
      path: '/setup-2fa';
      fullPath: '/admin/setup-2fa';
      preLoaderRoute: typeof AdminSetup2faRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/transactions': {
      id: '/admin/transactions';
      path: '/transactions';
      fullPath: '/admin/transactions';
      preLoaderRoute: typeof AdminTransactionsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/withdrawals': {
      id: '/admin/withdrawals';
      path: '/withdrawals';
      fullPath: '/admin/withdrawals';
      preLoaderRoute: typeof AdminWithdrawalsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/app/': {
      id: '/app/';
      path: '/';
      fullPath: '/app/';
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/notas-fiscais': {
      id: '/app/notas-fiscais';
      path: '/notas-fiscais';
      fullPath: '/app/notas-fiscais';
      preLoaderRoute: typeof AppNotasFiscaisRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/splits': {
      id: '/app/splits';
      path: '/splits';
      fullPath: '/app/splits';
      preLoaderRoute: typeof AppSplitsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/terms': {
      id: '/app/terms';
      path: '/terms';
      fullPath: '/app/terms';
      preLoaderRoute: typeof AppTermsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/transactions': {
      id: '/app/transactions';
      path: '/transactions';
      fullPath: '/app/transactions';
      preLoaderRoute: typeof AppTransactionsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/withdrawals': {
      id: '/app/withdrawals';
      path: '/withdrawals';
      fullPath: '/app/withdrawals';
      preLoaderRoute: typeof AppWithdrawalsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/dev/kit': {
      id: '/dev/kit';
      path: '/dev/kit';
      fullPath: '/dev/kit';
      preLoaderRoute: typeof DevKitRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forgot-password/': {
      id: '/forgot-password/';
      path: '/forgot-password';
      fullPath: '/forgot-password/';
      preLoaderRoute: typeof ForgotPasswordIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login/': {
      id: '/login/';
      path: '/login';
      fullPath: '/login/';
      preLoaderRoute: typeof LoginIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/no-access/': {
      id: '/no-access/';
      path: '/no-access';
      fullPath: '/no-access/';
      preLoaderRoute: typeof NoAccessIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/recover-2fa/': {
      id: '/recover-2fa/';
      path: '/recover-2fa';
      fullPath: '/recover-2fa/';
      preLoaderRoute: typeof Recover2faIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset-password/': {
      id: '/reset-password/';
      path: '/reset-password';
      fullPath: '/reset-password/';
      preLoaderRoute: typeof ResetPasswordIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signup/': {
      id: '/signup/';
      path: '/signup';
      fullPath: '/signup/';
      preLoaderRoute: typeof SignupIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/verify-email/': {
      id: '/verify-email/';
      path: '/verify-email';
      fullPath: '/verify-email/';
      preLoaderRoute: typeof VerifyEmailIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin/acquirers/': {
      id: '/admin/acquirers/';
      path: '/acquirers';
      fullPath: '/admin/acquirers/';
      preLoaderRoute: typeof AdminAcquirersIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/admins/': {
      id: '/admin/admins/';
      path: '/admins';
      fullPath: '/admin/admins/';
      preLoaderRoute: typeof AdminAdminsIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/alerts/': {
      id: '/admin/alerts/';
      path: '/alerts';
      fullPath: '/admin/alerts/';
      preLoaderRoute: typeof AdminAlertsIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/audit-log/': {
      id: '/admin/audit-log/';
      path: '/';
      fullPath: '/admin/audit-log/';
      preLoaderRoute: typeof AdminAuditLogIndexRouteImport;
      parentRoute: typeof AdminAuditLogRoute;
    };
    '/admin/audit-log/$id': {
      id: '/admin/audit-log/$id';
      path: '/$id';
      fullPath: '/admin/audit-log/$id';
      preLoaderRoute: typeof AdminAuditLogIdRouteImport;
      parentRoute: typeof AdminAuditLogRoute;
    };
    '/admin/kyc/': {
      id: '/admin/kyc/';
      path: '/';
      fullPath: '/admin/kyc/';
      preLoaderRoute: typeof AdminKycIndexRouteImport;
      parentRoute: typeof AdminKycRoute;
    };
    '/admin/kyc/$id': {
      id: '/admin/kyc/$id';
      path: '/$id';
      fullPath: '/admin/kyc/$id';
      preLoaderRoute: typeof AdminKycIdRouteImport;
      parentRoute: typeof AdminKycRoute;
    };
    '/admin/ledger/': {
      id: '/admin/ledger/';
      path: '/ledger';
      fullPath: '/admin/ledger/';
      preLoaderRoute: typeof AdminLedgerIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/rates/': {
      id: '/admin/rates/';
      path: '/rates';
      fullPath: '/admin/rates/';
      preLoaderRoute: typeof AdminRatesIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/reconciliation/': {
      id: '/admin/reconciliation/';
      path: '/';
      fullPath: '/admin/reconciliation/';
      preLoaderRoute: typeof AdminReconciliationIndexRouteImport;
      parentRoute: typeof AdminReconciliationRoute;
    };
    '/admin/reports/': {
      id: '/admin/reports/';
      path: '/reports';
      fullPath: '/admin/reports/';
      preLoaderRoute: typeof AdminReportsIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/sellers/': {
      id: '/admin/sellers/';
      path: '/';
      fullPath: '/admin/sellers/';
      preLoaderRoute: typeof AdminSellersIndexRouteImport;
      parentRoute: typeof AdminSellersRoute;
    };
    '/admin/sellers/$id': {
      id: '/admin/sellers/$id';
      path: '/$id';
      fullPath: '/admin/sellers/$id';
      preLoaderRoute: typeof AdminSellersIdRouteImport;
      parentRoute: typeof AdminSellersRoute;
    };
    '/admin/settings/': {
      id: '/admin/settings/';
      path: '/settings';
      fullPath: '/admin/settings/';
      preLoaderRoute: typeof AdminSettingsIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/system/': {
      id: '/admin/system/';
      path: '/system';
      fullPath: '/admin/system/';
      preLoaderRoute: typeof AdminSystemIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/transactions/': {
      id: '/admin/transactions/';
      path: '/';
      fullPath: '/admin/transactions/';
      preLoaderRoute: typeof AdminTransactionsIndexRouteImport;
      parentRoute: typeof AdminTransactionsRoute;
    };
    '/admin/transactions/$id': {
      id: '/admin/transactions/$id';
      path: '/$id';
      fullPath: '/admin/transactions/$id';
      preLoaderRoute: typeof AdminTransactionsIdRouteImport;
      parentRoute: typeof AdminTransactionsRoute;
    };
    '/admin/webhooks/inbox': {
      id: '/admin/webhooks/inbox';
      path: '/webhooks/inbox';
      fullPath: '/admin/webhooks/inbox';
      preLoaderRoute: typeof AdminWebhooksInboxRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/withdrawals/': {
      id: '/admin/withdrawals/';
      path: '/';
      fullPath: '/admin/withdrawals/';
      preLoaderRoute: typeof AdminWithdrawalsIndexRouteImport;
      parentRoute: typeof AdminWithdrawalsRoute;
    };
    '/admin/withdrawals/$id': {
      id: '/admin/withdrawals/$id';
      path: '/$id';
      fullPath: '/admin/withdrawals/$id';
      preLoaderRoute: typeof AdminWithdrawalsIdRouteImport;
      parentRoute: typeof AdminWithdrawalsRoute;
    };
    '/app/balance/': {
      id: '/app/balance/';
      path: '/balance';
      fullPath: '/app/balance/';
      preLoaderRoute: typeof AppBalanceIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/developers/': {
      id: '/app/developers/';
      path: '/developers';
      fullPath: '/app/developers/';
      preLoaderRoute: typeof AppDevelopersIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/reports/': {
      id: '/app/reports/';
      path: '/reports';
      fullPath: '/app/reports/';
      preLoaderRoute: typeof AppReportsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/settings/': {
      id: '/app/settings/';
      path: '/settings';
      fullPath: '/app/settings/';
      preLoaderRoute: typeof AppSettingsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/splits/': {
      id: '/app/splits/';
      path: '/';
      fullPath: '/app/splits/';
      preLoaderRoute: typeof AppSplitsIndexRouteImport;
      parentRoute: typeof AppSplitsRoute;
    };
    '/app/splits/$id': {
      id: '/app/splits/$id';
      path: '/$id';
      fullPath: '/app/splits/$id';
      preLoaderRoute: typeof AppSplitsIdRouteImport;
      parentRoute: typeof AppSplitsRoute;
    };
    '/app/splits/authorizations': {
      id: '/app/splits/authorizations';
      path: '/authorizations';
      fullPath: '/app/splits/authorizations';
      preLoaderRoute: typeof AppSplitsAuthorizationsRouteImport;
      parentRoute: typeof AppSplitsRoute;
    };
    '/app/transactions/': {
      id: '/app/transactions/';
      path: '/';
      fullPath: '/app/transactions/';
      preLoaderRoute: typeof AppTransactionsIndexRouteImport;
      parentRoute: typeof AppTransactionsRoute;
    };
    '/app/transactions/$id': {
      id: '/app/transactions/$id';
      path: '/$id';
      fullPath: '/app/transactions/$id';
      preLoaderRoute: typeof AppTransactionsIdRouteImport;
      parentRoute: typeof AppTransactionsRoute;
    };
    '/app/withdrawals/': {
      id: '/app/withdrawals/';
      path: '/';
      fullPath: '/app/withdrawals/';
      preLoaderRoute: typeof AppWithdrawalsIndexRouteImport;
      parentRoute: typeof AppWithdrawalsRoute;
    };
    '/app/withdrawals/$id': {
      id: '/app/withdrawals/$id';
      path: '/$id';
      fullPath: '/app/withdrawals/$id';
      preLoaderRoute: typeof AppWithdrawalsIdRouteImport;
      parentRoute: typeof AppWithdrawalsRoute;
    };
    '/admin/reconciliation/runs/$id': {
      id: '/admin/reconciliation/runs/$id';
      path: '/runs/$id';
      fullPath: '/admin/reconciliation/runs/$id';
      preLoaderRoute: typeof AdminReconciliationRunsIdRouteImport;
      parentRoute: typeof AdminReconciliationRoute;
    };
    '/admin/webhooks/deliveries/': {
      id: '/admin/webhooks/deliveries/';
      path: '/webhooks/deliveries';
      fullPath: '/admin/webhooks/deliveries/';
      preLoaderRoute: typeof AdminWebhooksDeliveriesIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/webhooks/inbox/': {
      id: '/admin/webhooks/inbox/';
      path: '/';
      fullPath: '/admin/webhooks/inbox/';
      preLoaderRoute: typeof AdminWebhooksInboxIndexRouteImport;
      parentRoute: typeof AdminWebhooksInboxRoute;
    };
    '/admin/webhooks/inbox/$id': {
      id: '/admin/webhooks/inbox/$id';
      path: '/$id';
      fullPath: '/admin/webhooks/inbox/$id';
      preLoaderRoute: typeof AdminWebhooksInboxIdRouteImport;
      parentRoute: typeof AdminWebhooksInboxRoute;
    };
    '/app/developers/api-keys/': {
      id: '/app/developers/api-keys/';
      path: '/developers/api-keys';
      fullPath: '/app/developers/api-keys/';
      preLoaderRoute: typeof AppDevelopersApiKeysIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/developers/docs/': {
      id: '/app/developers/docs/';
      path: '/developers/docs';
      fullPath: '/app/developers/docs/';
      preLoaderRoute: typeof AppDevelopersDocsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/developers/events/': {
      id: '/app/developers/events/';
      path: '/developers/events';
      fullPath: '/app/developers/events/';
      preLoaderRoute: typeof AppDevelopersEventsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/developers/webhooks/': {
      id: '/app/developers/webhooks/';
      path: '/developers/webhooks';
      fullPath: '/app/developers/webhooks/';
      preLoaderRoute: typeof AppDevelopersWebhooksIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/settings/integrations/': {
      id: '/app/settings/integrations/';
      path: '/settings/integrations';
      fullPath: '/app/settings/integrations/';
      preLoaderRoute: typeof AppSettingsIntegrationsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/settings/kyc/': {
      id: '/app/settings/kyc/';
      path: '/settings/kyc';
      fullPath: '/app/settings/kyc/';
      preLoaderRoute: typeof AppSettingsKycIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/settings/notifications/': {
      id: '/app/settings/notifications/';
      path: '/settings/notifications';
      fullPath: '/app/settings/notifications/';
      preLoaderRoute: typeof AppSettingsNotificationsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/settings/pix-keys/': {
      id: '/app/settings/pix-keys/';
      path: '/settings/pix-keys';
      fullPath: '/app/settings/pix-keys/';
      preLoaderRoute: typeof AppSettingsPixKeysIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/settings/rates/': {
      id: '/app/settings/rates/';
      path: '/settings/rates';
      fullPath: '/app/settings/rates/';
      preLoaderRoute: typeof AppSettingsRatesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/settings/security/': {
      id: '/app/settings/security/';
      path: '/settings/security';
      fullPath: '/app/settings/security/';
      preLoaderRoute: typeof AppSettingsSecurityIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/developers/webhooks/deliveries/': {
      id: '/app/developers/webhooks/deliveries/';
      path: '/developers/webhooks/deliveries';
      fullPath: '/app/developers/webhooks/deliveries/';
      preLoaderRoute: typeof AppDevelopersWebhooksDeliveriesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
  }
}

interface AdminAuditLogRouteChildren {
  AdminAuditLogIdRoute: typeof AdminAuditLogIdRoute;
  AdminAuditLogIndexRoute: typeof AdminAuditLogIndexRoute;
}

const AdminAuditLogRouteChildren: AdminAuditLogRouteChildren = {
  AdminAuditLogIdRoute: AdminAuditLogIdRoute,
  AdminAuditLogIndexRoute: AdminAuditLogIndexRoute,
};

const AdminAuditLogRouteWithChildren = AdminAuditLogRoute._addFileChildren(
  AdminAuditLogRouteChildren,
);

interface AdminKycRouteChildren {
  AdminKycIdRoute: typeof AdminKycIdRoute;
  AdminKycIndexRoute: typeof AdminKycIndexRoute;
}

const AdminKycRouteChildren: AdminKycRouteChildren = {
  AdminKycIdRoute: AdminKycIdRoute,
  AdminKycIndexRoute: AdminKycIndexRoute,
};

const AdminKycRouteWithChildren = AdminKycRoute._addFileChildren(
  AdminKycRouteChildren,
);

interface AdminReconciliationRouteChildren {
  AdminReconciliationIndexRoute: typeof AdminReconciliationIndexRoute;
  AdminReconciliationRunsIdRoute: typeof AdminReconciliationRunsIdRoute;
}

const AdminReconciliationRouteChildren: AdminReconciliationRouteChildren = {
  AdminReconciliationIndexRoute: AdminReconciliationIndexRoute,
  AdminReconciliationRunsIdRoute: AdminReconciliationRunsIdRoute,
};

const AdminReconciliationRouteWithChildren =
  AdminReconciliationRoute._addFileChildren(AdminReconciliationRouteChildren);

interface AdminSellersRouteChildren {
  AdminSellersIdRoute: typeof AdminSellersIdRoute;
  AdminSellersIndexRoute: typeof AdminSellersIndexRoute;
}

const AdminSellersRouteChildren: AdminSellersRouteChildren = {
  AdminSellersIdRoute: AdminSellersIdRoute,
  AdminSellersIndexRoute: AdminSellersIndexRoute,
};

const AdminSellersRouteWithChildren = AdminSellersRoute._addFileChildren(
  AdminSellersRouteChildren,
);

interface AdminTransactionsRouteChildren {
  AdminTransactionsIdRoute: typeof AdminTransactionsIdRoute;
  AdminTransactionsIndexRoute: typeof AdminTransactionsIndexRoute;
}

const AdminTransactionsRouteChildren: AdminTransactionsRouteChildren = {
  AdminTransactionsIdRoute: AdminTransactionsIdRoute,
  AdminTransactionsIndexRoute: AdminTransactionsIndexRoute,
};

const AdminTransactionsRouteWithChildren =
  AdminTransactionsRoute._addFileChildren(AdminTransactionsRouteChildren);

interface AdminWithdrawalsRouteChildren {
  AdminWithdrawalsIdRoute: typeof AdminWithdrawalsIdRoute;
  AdminWithdrawalsIndexRoute: typeof AdminWithdrawalsIndexRoute;
}

const AdminWithdrawalsRouteChildren: AdminWithdrawalsRouteChildren = {
  AdminWithdrawalsIdRoute: AdminWithdrawalsIdRoute,
  AdminWithdrawalsIndexRoute: AdminWithdrawalsIndexRoute,
};

const AdminWithdrawalsRouteWithChildren =
  AdminWithdrawalsRoute._addFileChildren(AdminWithdrawalsRouteChildren);

interface AdminWebhooksInboxRouteChildren {
  AdminWebhooksInboxIdRoute: typeof AdminWebhooksInboxIdRoute;
  AdminWebhooksInboxIndexRoute: typeof AdminWebhooksInboxIndexRoute;
}

const AdminWebhooksInboxRouteChildren: AdminWebhooksInboxRouteChildren = {
  AdminWebhooksInboxIdRoute: AdminWebhooksInboxIdRoute,
  AdminWebhooksInboxIndexRoute: AdminWebhooksInboxIndexRoute,
};

const AdminWebhooksInboxRouteWithChildren =
  AdminWebhooksInboxRoute._addFileChildren(AdminWebhooksInboxRouteChildren);

interface AdminRouteChildren {
  AdminAuditLogRoute: typeof AdminAuditLogRouteWithChildren;
  AdminChangePasswordRoute: typeof AdminChangePasswordRoute;
  AdminInvitesRoute: typeof AdminInvitesRoute;
  AdminKycRoute: typeof AdminKycRouteWithChildren;
  AdminNotasFiscaisRoute: typeof AdminNotasFiscaisRoute;
  AdminReconciliationRoute: typeof AdminReconciliationRouteWithChildren;
  AdminSellersRoute: typeof AdminSellersRouteWithChildren;
  AdminSetup2faRoute: typeof AdminSetup2faRoute;
  AdminTransactionsRoute: typeof AdminTransactionsRouteWithChildren;
  AdminWithdrawalsRoute: typeof AdminWithdrawalsRouteWithChildren;
  AdminIndexRoute: typeof AdminIndexRoute;
  AdminWebhooksInboxRoute: typeof AdminWebhooksInboxRouteWithChildren;
  AdminAcquirersIndexRoute: typeof AdminAcquirersIndexRoute;
  AdminAdminsIndexRoute: typeof AdminAdminsIndexRoute;
  AdminAlertsIndexRoute: typeof AdminAlertsIndexRoute;
  AdminLedgerIndexRoute: typeof AdminLedgerIndexRoute;
  AdminRatesIndexRoute: typeof AdminRatesIndexRoute;
  AdminReportsIndexRoute: typeof AdminReportsIndexRoute;
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute;
  AdminSystemIndexRoute: typeof AdminSystemIndexRoute;
  AdminWebhooksDeliveriesIndexRoute: typeof AdminWebhooksDeliveriesIndexRoute;
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditLogRoute: AdminAuditLogRouteWithChildren,
  AdminChangePasswordRoute: AdminChangePasswordRoute,
  AdminInvitesRoute: AdminInvitesRoute,
  AdminKycRoute: AdminKycRouteWithChildren,
  AdminNotasFiscaisRoute: AdminNotasFiscaisRoute,
  AdminReconciliationRoute: AdminReconciliationRouteWithChildren,
  AdminSellersRoute: AdminSellersRouteWithChildren,
  AdminSetup2faRoute: AdminSetup2faRoute,
  AdminTransactionsRoute: AdminTransactionsRouteWithChildren,
  AdminWithdrawalsRoute: AdminWithdrawalsRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminWebhooksInboxRoute: AdminWebhooksInboxRouteWithChildren,
  AdminAcquirersIndexRoute: AdminAcquirersIndexRoute,
  AdminAdminsIndexRoute: AdminAdminsIndexRoute,
  AdminAlertsIndexRoute: AdminAlertsIndexRoute,
  AdminLedgerIndexRoute: AdminLedgerIndexRoute,
  AdminRatesIndexRoute: AdminRatesIndexRoute,
  AdminReportsIndexRoute: AdminReportsIndexRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminSystemIndexRoute: AdminSystemIndexRoute,
  AdminWebhooksDeliveriesIndexRoute: AdminWebhooksDeliveriesIndexRoute,
};

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren);

interface AppSplitsRouteChildren {
  AppSplitsIdRoute: typeof AppSplitsIdRoute;
  AppSplitsAuthorizationsRoute: typeof AppSplitsAuthorizationsRoute;
  AppSplitsIndexRoute: typeof AppSplitsIndexRoute;
}

const AppSplitsRouteChildren: AppSplitsRouteChildren = {
  AppSplitsIdRoute: AppSplitsIdRoute,
  AppSplitsAuthorizationsRoute: AppSplitsAuthorizationsRoute,
  AppSplitsIndexRoute: AppSplitsIndexRoute,
};

const AppSplitsRouteWithChildren = AppSplitsRoute._addFileChildren(
  AppSplitsRouteChildren,
);

interface AppTransactionsRouteChildren {
  AppTransactionsIdRoute: typeof AppTransactionsIdRoute;
  AppTransactionsIndexRoute: typeof AppTransactionsIndexRoute;
}

const AppTransactionsRouteChildren: AppTransactionsRouteChildren = {
  AppTransactionsIdRoute: AppTransactionsIdRoute,
  AppTransactionsIndexRoute: AppTransactionsIndexRoute,
};

const AppTransactionsRouteWithChildren = AppTransactionsRoute._addFileChildren(
  AppTransactionsRouteChildren,
);

interface AppWithdrawalsRouteChildren {
  AppWithdrawalsIdRoute: typeof AppWithdrawalsIdRoute;
  AppWithdrawalsIndexRoute: typeof AppWithdrawalsIndexRoute;
}

const AppWithdrawalsRouteChildren: AppWithdrawalsRouteChildren = {
  AppWithdrawalsIdRoute: AppWithdrawalsIdRoute,
  AppWithdrawalsIndexRoute: AppWithdrawalsIndexRoute,
};

const AppWithdrawalsRouteWithChildren = AppWithdrawalsRoute._addFileChildren(
  AppWithdrawalsRouteChildren,
);

interface AppRouteChildren {
  AppNotasFiscaisRoute: typeof AppNotasFiscaisRoute;
  AppSplitsRoute: typeof AppSplitsRouteWithChildren;
  AppTermsRoute: typeof AppTermsRoute;
  AppTransactionsRoute: typeof AppTransactionsRouteWithChildren;
  AppWithdrawalsRoute: typeof AppWithdrawalsRouteWithChildren;
  AppIndexRoute: typeof AppIndexRoute;
  AppBalanceIndexRoute: typeof AppBalanceIndexRoute;
  AppDevelopersIndexRoute: typeof AppDevelopersIndexRoute;
  AppReportsIndexRoute: typeof AppReportsIndexRoute;
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute;
  AppDevelopersApiKeysIndexRoute: typeof AppDevelopersApiKeysIndexRoute;
  AppDevelopersDocsIndexRoute: typeof AppDevelopersDocsIndexRoute;
  AppDevelopersEventsIndexRoute: typeof AppDevelopersEventsIndexRoute;
  AppDevelopersWebhooksIndexRoute: typeof AppDevelopersWebhooksIndexRoute;
  AppSettingsIntegrationsIndexRoute: typeof AppSettingsIntegrationsIndexRoute;
  AppSettingsKycIndexRoute: typeof AppSettingsKycIndexRoute;
  AppSettingsNotificationsIndexRoute: typeof AppSettingsNotificationsIndexRoute;
  AppSettingsPixKeysIndexRoute: typeof AppSettingsPixKeysIndexRoute;
  AppSettingsRatesIndexRoute: typeof AppSettingsRatesIndexRoute;
  AppSettingsSecurityIndexRoute: typeof AppSettingsSecurityIndexRoute;
  AppDevelopersWebhooksDeliveriesIndexRoute: typeof AppDevelopersWebhooksDeliveriesIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppNotasFiscaisRoute: AppNotasFiscaisRoute,
  AppSplitsRoute: AppSplitsRouteWithChildren,
  AppTermsRoute: AppTermsRoute,
  AppTransactionsRoute: AppTransactionsRouteWithChildren,
  AppWithdrawalsRoute: AppWithdrawalsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppBalanceIndexRoute: AppBalanceIndexRoute,
  AppDevelopersIndexRoute: AppDevelopersIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppDevelopersApiKeysIndexRoute: AppDevelopersApiKeysIndexRoute,
  AppDevelopersDocsIndexRoute: AppDevelopersDocsIndexRoute,
  AppDevelopersEventsIndexRoute: AppDevelopersEventsIndexRoute,
  AppDevelopersWebhooksIndexRoute: AppDevelopersWebhooksIndexRoute,
  AppSettingsIntegrationsIndexRoute: AppSettingsIntegrationsIndexRoute,
  AppSettingsKycIndexRoute: AppSettingsKycIndexRoute,
  AppSettingsNotificationsIndexRoute: AppSettingsNotificationsIndexRoute,
  AppSettingsPixKeysIndexRoute: AppSettingsPixKeysIndexRoute,
  AppSettingsRatesIndexRoute: AppSettingsRatesIndexRoute,
  AppSettingsSecurityIndexRoute: AppSettingsSecurityIndexRoute,
  AppDevelopersWebhooksDeliveriesIndexRoute:
    AppDevelopersWebhooksDeliveriesIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  DevKitRoute: DevKitRoute,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  NoAccessIndexRoute: NoAccessIndexRoute,
  Recover2faIndexRoute: Recover2faIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  SignupIndexRoute: SignupIndexRoute,
  VerifyEmailIndexRoute: VerifyEmailIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
